import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmbedConfig  {
    _originalTypeClassName = "zERP.BO.EmbedConfig";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmbedConfig.translate = translateService;
}
this.type = null;
this.id = null;
this.embedUrl = null;
this.accessToken = null;
this.tokenType = null;
this.permissions = null;
this.EmbedConfigKey = null;
this._key = this.EmbedConfigKey = 0; 
}

static translate: TranslateService;
_key: any;
type:any;
id:any;
embedUrl:any;
accessToken:any;
tokenType:any;
permissions:any;
settings:any;
private _EmbedConfigKey:any;
get EmbedConfigKey(): any {
    return this._EmbedConfigKey;
  }
set EmbedConfigKey(value: any) {
    this._EmbedConfigKey = value;
    this._key = value;
  }
static setsettings = ($this, value) => {
var oldValue = $this.settings;
$this.settings = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmbedConfigKey == null || $this.EmbedConfigKey == 0;
            }


}